import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import { LOCALE, selectedLocaleState } from 'translations';

const useLocale = () => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useRecoilState<LOCALE>(selectedLocaleState);
  const [initialLanguage, initialRegion] = locale.split('_');
  const [language, setLanguage] = useState<string>(initialLanguage);
  const [region, setRegion] = useState<string>(initialRegion);

  const changeLocale = (selectedLocale: LOCALE) => {
    const [selectedLanguage, selectedRegion] = selectedLocale.split('_');

    i18n.changeLanguage(selectedLanguage);
    moment.locale(selectedLanguage);
    localStorage.setItem('locale', selectedLocale);

    setLocale(selectedLocale);
    setLanguage(selectedLanguage);
    setRegion(selectedRegion);
  };

  return {
    locale,
    region,
    language,
    changeLocale,
  };
};

export default useLocale;
